// ============================================================================
// Assurance - Page Création (conteneur, sous-routes)
// Affiche la page enfant selon l'URL :
//   /assurance/souscription/:idProduit         -> SouscriptionForm
//   /assurance/demande-assistance/:idSouscription -> DemandeAssistanceForm
//   (fallback)                                    -> ProduitAssistanceList
// ============================================================================

import { useParams } from 'react-router-dom';
import ProduitAssistanceList from './ProduitAssistanceList';
import SouscriptionForm from './SouscriptionForm';
import DemandeAssistanceForm from './DemandeAssistanceForm';

const CreationPage = () => {
  const { idProduit, idSouscription } = useParams<{ idProduit?: string; idSouscription?: string }>();

  if (idSouscription) return <DemandeAssistanceForm />;
  if (idProduit) return <SouscriptionForm />;
  return <ProduitAssistanceList />;
};

export default CreationPage;
